import React, {useEffect, useState, useCallback, useRef, useContext, useMemo} from 'react';
import { connect } from 'react-redux';
import { PlusOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { Button, Col, Row, Spin } from 'antd';
import { ContainerAggregation } from './components';
import ContainerGauges from './components/containerGauges';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import { apiUrl } from '../../app.config';
import {
    dispensaries as dispensaryServices
} from '../../services';
import {
    getPagePermissions,
    DISPENSARY_PERMISSION
} from '../../security/permissions';

import gas_pump from './../../assets/images/gas_pump.svg';
import './styles.css';
import DistributionPointSelected from '../../context/MyDistributionPoint';

const Containers = ({ pagePermissions }) => {
    const [mainView, setMainView] = useState(true);
    const [addContainerForm, setAddContainerForm] = useState(false);
    const [areThereContainers, setAreThereContainers] = useState(false);
    const [containers, setContainers] = useState([]);
    const [loadingContainers, setLoadingContainers] = useState(false);

    const { distributionPoint } = useContext(DistributionPointSelected);

    const stompClientRef = useRef(null);
    const isMountedRef = useRef(true);

    const fetchContainers = useCallback(() => {
        setLoadingContainers(true);
        dispensaryServices.get(`distributionPoints/${distributionPoint.id}/containers`)
            .then(response => {
                console.log('RESPONSE', response)
                if (response.length > 0) {
                    const updatedContainers = response.map(r => ({ ...r }));
                    setAreThereContainers(true);
                    setContainers(updatedContainers);
                } else {
                    setAreThereContainers(false);
                    setContainers([]);
                }
                setLoadingContainers(false);
            });
    }, [distributionPoint]);

    const connect = useCallback(() => {
        if (stompClientRef.current) {
            stompClientRef.current.subscribe('/topic/gauges', (messageOutput) => {
                const data = JSON.parse(messageOutput.body);
                if (data.length > 0) {
                    setAreThereContainers(true);
                    setContainers(data);
                } else {
                    setAreThereContainers(false);
                }
            });
        }
    }, []);

    const setupWebSocket = useCallback(() => {
        const socket = SockJS(`${apiUrl}volumetric-control`);
        stompClientRef.current = Stomp.over(socket);
        stompClientRef.current.connect({}, connect);
    }, [connect]);

    useEffect(() => {
        isMountedRef.current = true;
        fetchContainers();
        setupWebSocket();

    }, [distributionPoint, setupWebSocket]);

    const showAddContainerForm = () => {
        setMainView(false);
        setAddContainerForm(true);
    };

    const handleAddContainerClick = () => {
        fetchContainers();
        setMainView(true);
        setAddContainerForm(false);
    };

    const handleCancelClick = (form) => {
        setMainView(true);
        if (form === 'addContainerForm') setAddContainerForm(false);
    };

    const handleUpdateContainers = () => {
        fetchContainers();
    };

    const onGaugeChange = () => {
        setContainers([]);
        fetchContainers();
    };

    const cardItems = useMemo(() =>
            containers.map((value) => (
                <Col key={value.containerKey} span={12} style={{ marginBottom: '24px' }}>
                    <ContainerGauges
                        onGaugeChange={onGaugeChange}
                        container={value}
                        onUpdateContainers={handleUpdateContainers}
                    />
                </Col>
            )),
        [containers]
    );

    return (
        <Spin size="large" tip="Cargando..." spinning={loadingContainers}>
            {mainView &&
                <Form layout='vertical'>
                    {areThereContainers ? (
                        <Col>
                            <Row style={{ marginBottom: '24px' }}>
                                {pagePermissions.add &&
                                    <Button
                                        className="customized-primary"
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={showAddContainerForm}
                                    >
                                        Agregar contenedor
                                    </Button>}
                            </Row>
                            <Row gutter={24}>
                                {cardItems}
                            </Row>
                        </Col>
                    ) : (
                        <div className="center-div">
                            <img src={gas_pump} alt="Dispensario" />
                            <div style={{ margin: '8px' }}>
                                <label>Sin contenedores agregados</label>
                            </div>
                            {pagePermissions.add &&
                                <Button
                                    className="customized-primary"
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={showAddContainerForm}
                                >
                                    Agregar contenedor
                                </Button>}
                        </div>
                    )}
                </Form>
            }
            {addContainerForm &&
                <ContainerAggregation
                    onAddContainerClick={handleAddContainerClick}
                    onCancelClick={() => handleCancelClick('addContainerForm')}
                />}
        </Spin>
    );
};

const mapStateToProps = ({ userData, userData: { permissions } }) => ({
    userData,
    pagePermissions: getPagePermissions(DISPENSARY_PERMISSION, permissions)
});

export default connect(mapStateToProps)(Containers);
